/*
  Product card ratings from Stamped.

  Each card renders its own stars + "N reviews" (from Shopify's review metafields) and a hidden
  .stamped-product-reviews-badge. Stamped fills that badge with its live rating and count — the
  same lookup the product page badge uses — and this script copies those numbers into the card,
  so the design stays ours while the numbers match Stamped.

  Cards added later (related products loading, collection filtering, search) get picked up by a
  MutationObserver, which asks Stamped to load their badges and then syncs them.
*/
(function () {
  const CARD_SELECTOR = '[data-stamped-rating]';
  const SOURCE_SELECTOR = '.stamped-product-reviews-badge';

  function readStamped(source) {
    const ratingEl = source.querySelector('[data-rating]');
    const countEl = source.querySelector('[data-reviews]');
    const rating = ratingEl ? parseFloat(ratingEl.getAttribute('data-rating')) : NaN;
    let count = countEl ? parseInt(countEl.getAttribute('data-reviews'), 10) : NaN;

    if (Number.isNaN(count)) {
      const caption = source.querySelector('.stamped-badge-caption') || source;
      const match = caption.textContent.replace(/[,.\s](?=\d{3}\b)/g, '').match(/\d+/);
      count = match ? parseInt(match[0], 10) : NaN;
    }

    return { rating, count };
  }

  function syncCard(card) {
    const source = card.querySelector(SOURCE_SELECTOR);
    if (!source || !source.children.length) return;

    const { rating, count } = readStamped(source);
    if (Number.isNaN(count)) return;

    if (count === 0) {
      card.hidden = true;
      return;
    }

    if (!Number.isNaN(rating)) {
      const filled = Math.max(0, Math.min(5, Math.round(rating)));
      card.querySelectorAll('.related-products__star').forEach((star, index) => {
        star.classList.toggle('related-products__star--off', index + 1 > filled);
      });
    }

    const label = card.dataset[count === 1 ? 'labelOne' : 'labelOther'];
    const countEl = card.querySelector('[data-stamped-count]');
    if (label && countEl) countEl.textContent = label.replace('[count]', count);

    card.hidden = false;
  }

  function syncAll() {
    document.querySelectorAll(CARD_SELECTOR).forEach(syncCard);
  }

  // Ask Stamped once for badges it hasn't filled yet (cards inserted after its first pass).
  function requestNewBadges() {
    if (!window.StampedFn || typeof window.StampedFn.loadBadges !== 'function') return;

    const pending = Array.from(document.querySelectorAll(`${CARD_SELECTOR} ${SOURCE_SELECTOR}`)).filter(
      (source) => !source.children.length && !source.dataset.stampedRequested
    );
    if (!pending.length) return;

    pending.forEach((source) => (source.dataset.stampedRequested = 'true'));
    window.StampedFn.loadBadges();
  }

  let timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      requestNewBadges();
      syncAll();
    }, 150);
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
